import "./assets/css/App.css";
import "./assets/css/media.css";
import "./assets/css/common.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SideBar from "./Components/SideBar/SideBar";
import Darkmode from "./Components/DarkMode/Darkmode";
import Header from "./Components/Header/Header";
import HeaderNew from "./Components/Header/HeaderNew";
import SidebarTwo from "./Components/SideBar/SidebarTwo";
import SidebarOne from "./Components/SideBar/SidebarOne";
import Component from "./Components/Component/Component";
import Home from "./Components/Home/Home";
import MegaMenu from "./Components/Header/MegaMenu";
import ContactUs from "./Components/Auth/ContactUs";
import { ToastContainer } from "react-toastify";
import Error404 from "./Components/Error/Error404";
import UnderMaintenance from "./Components/Error/UnderMaintenance";
import ScrollToTop from "./Components/ScrollTop/ScrollToTop.jsx";


// Outter pages
import Currencies from "./Components/OutterPages/Product/Currencies.js";
import CryptoCurrencies from "./Components/OutterPages/Product/CryptoCurrencies.js";
import Commodities from "./Components/OutterPages/Product/Commodities.js";
import Indicies from "./Components/OutterPages/Product/Indicies.js";

// economic calender
import EconomicCalender from "./Components/OutterPages/TradingTools/EconomicCalender.js";
import TradingTools from "./Components/OutterPages/TradingTools/TradingTools.js";
//  platform
import CopyTrading from "./Components/OutterPages/Plantform/CopyTrading.js";
import PAMM from "./Components/OutterPages/Plantform/PAMM.js";
import MT5Trader from "./Components/OutterPages/Plantform/MT5Trader.js";
import NeonCursor from "./Components/NeonCursor/NeonCursor.js";

import AboutUs from "./Components/OutterPages/AboutUs/AboutUs.js";
import FAQOuter from "./Components/OutterPages/FAQ/FAQ.js";
import Instruments from "./Components/OutterPages/Instruments/Instruments.js";
import AffliateProgram from "./Components/OutterPages/AffliateProgram/AffliateProgram.js";
import IntroductionBroker from "./Components/OutterPages/IntroductionBroker/IntroductionBroker.js";


function App() {
  return (
    <div className="App">
      {/* <HelmetProvider> */}

      <Router>
        <ScrollToTop />
        {/* <NeonCursor/> */}
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/sidebar" element={<SideBar />}></Route>
          <Route path="/header" element={<Header />}></Route>
          <Route path="/headerNew" element={<HeaderNew />}></Route>
          <Route exact path="/darkmode" element={<Darkmode />} />
          <Route path="/sidebartwo" element={<SidebarTwo />} />
          <Route path="/component" element={<Component />} />
          <Route path="/mega" element={<MegaMenu />} />
          <Route path="/sidebarone" element={<SidebarOne />} />
          {/* <Route path="/dash" element={<PersonalArea />} /> */}
          {/* cms my account page */}

          {/* Authentication */}
          <Route path="/contactus" element={<ContactUs />} />
          {/* <Route path="/faq" element={<Faq />} /> */}


          {/* Error404 */}
          <Route path="/maintenance" element={<UnderMaintenance />} />
          <Route path="*" element={<Error404 />} />

      
          {/* outter pages */}
          <Route path="/currencies" element={<Currencies />} />
          <Route path="/crypto-currencies" element={<CryptoCurrencies />} />
          <Route path="/commodities" element={<Commodities />} />
          <Route path="/indicies" element={<Indicies />} />

          {/* economic calender  */}
          {/* <Route path="/economic-calender" element={<EconomicCalender />} /> */}
          <Route path="/trading-tools" element={<TradingTools />} />

          {/* platform  */}
          <Route path="/copy-trading" element={<CopyTrading />} />
          <Route path="/pamm" element={<PAMM />} />
          <Route path="/mt5-trader" element={<MT5Trader />} />

          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/faq" element={<FAQOuter />} />
          <Route path="/instruments" element={<Instruments />} />
          <Route path="/affliate-program" element={<AffliateProgram />} />
          <Route path="/introduction-broker" element={<IntroductionBroker />} />

        </Routes>
        <ToastContainer autoClose={2000} position="top-right" />
      </Router>
      {/* </HelmetProvider> */}
    </div>
  );
}

export default App;
